import { Button, Checkbox, FormControlLabel, Grid2, TextField } from "@mui/material";
import classnames from "classnames";
import Tag from "components/common/Tag";
import React, { useState } from "react";
import { ChromePicker } from "react-color";
import TagsService from "services/tagsService";
import "./styles.scss";

const SettingsTagListItem = ({ value, isDeleted, color, id, order }) => {
    const [editing, setEditing] = useState(false);
    const [innerColor, setInnerColor] = useState(color);
    const [name, setName] = useState(value);
    const [disabled, setDisabled] = useState(isDeleted);
    const [openColorPicker, setOpenColorPicker] = useState(false);

    const handleDisabled = (updatedValue) => {
        TagsService.edit({
            id,
            deleted: updatedValue,
            value: name,
            order,
            color: innerColor,
        });
        setDisabled(updatedValue);
    };

    const saveChanges = () => {
        TagsService.edit({
            color: innerColor,
            id,
            value: name,
            order,
            deleted: disabled,
        }).then(() => setEditing(false));
    };

    const selectColor = () => {
        setOpenColorPicker(!openColorPicker);
    };

    return (
        (<Grid2 className={classnames("settings-tag-list-item", { disabled })} container>
            <Grid2 paddingLeft={4} paddingRight={8}
                size={{
                    xs: 12,
                    md: 4
                }}>
                {!editing && <p className="title">{name}</p>}
                {editing && (
                    <React.Fragment>
                        <TextField
                            label="Name"
                            margin="normal"
                            variant="outlined"
                            name="tagName"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                        <Button
                            variant={"contained"}
                            size="small"
                            color={"secondary"}
                            style={{ marginTop: 15 }}
                            onClick={selectColor}
                        >
                            Select Color
                        </Button>
                        {openColorPicker && (
                            <ChromePicker
                                color={innerColor}
                                onChangeComplete={(color) => setInnerColor(color.hex)}
                                disableAlpha
                            />
                        )}
                    </React.Fragment>
                )}
            </Grid2>
            <Grid2
                size={{
                    xs: 12,
                    md: 4
                }}>
                <span style={{ margin: "5px 15px 5px 0", display: "inline-block" }}>Preview:</span>
                <Tag name={name} color={innerColor} />
            </Grid2>
            <Grid2
                size={{
                    md: 2,
                    xs: 6
                }}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={disabled}
                            onChange={(e) => handleDisabled(e.target.checked)}
                            inputProps={{ "aria-label": "select all desserts" }}
                        />
                    }
                    label="Disabled"
                />
            </Grid2>
            <Grid2
                className="actions"
                style={{ display: "flex", justifyContent: "flex-end" }}
                size={{
                    xs: 12,
                    md: 2
                }}>
                {editing && (
                    <React.Fragment>
                        <div style={{ position: "relative", paddingTop: 7 }}>
                            <Button variant={"contained"} size="small" color={"primary"} onClick={saveChanges}>
                                Save
                            </Button>
                        </div>
                    </React.Fragment>
                )}
                {!editing && (
                    <div>
                        <Button variant={"contained"} size="small" color={"primary"} onClick={() => setEditing(true)}>
                            Edit
                        </Button>
                    </div>
                )}
            </Grid2>
        </Grid2>)
    );
};

export default SettingsTagListItem;
